
import Vue from 'vue'
import moment from 'moment'
import { functions } from '../services/firebaseAdapter'
import { OrganizationSunsetInterface } from '@/types/interfaces'
import { emptyOrganizationSunset, isOrgSunsetActive } from '@/services/orgSunset'

export default Vue.extend({
  name: 'SuperAdmin',
  data() {
    return {
      newOrganizationId: '',
      createdOrganizationId: '',
      isCreatingOrganization: false,
      hasCreatedOrganization: false,
      sunsetOrgId: '',
      sunsetOrgLoaded: false,
      isLoadingSunset: false,
      isSavingSunset: false,
      loadedSunset: emptyOrganizationSunset() as OrganizationSunsetInterface,
      sunsetDraft: {
        effectiveAtLocal: '',
        titleDe: '',
        titleEn: '',
        bannerHeadlineDe: '',
        bannerHeadlineEn: '',
        bannerDetailsDe: '',
        bannerDetailsEn: '',
        messageDe: '',
        messageEn: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
      },
    }
  },
  computed: {
    currentUserId(): string {
      return this.$store.getters.userId
    },
    currentUserEmail(): string {
      return this.$store.getters.userEmail
    },
    sunsetPreviewActive(): boolean {
      if (!this.sunsetDraft.effectiveAtLocal) return false
      return isOrgSunsetActive({
        ...this.loadedSunset,
        effectiveAt: new Date(this.sunsetDraft.effectiveAtLocal),
      })
    },
  },
  methods: {
    applySunsetToDraft(sunset: OrganizationSunsetInterface) {
      this.loadedSunset = sunset
      this.sunsetDraft = {
        effectiveAtLocal: sunset.effectiveAt
          ? moment(sunset.effectiveAt).format('YYYY-MM-DDTHH:mm')
          : '',
        titleDe: sunset.titleDe || '',
        titleEn: sunset.titleEn || '',
        bannerHeadlineDe: sunset.bannerHeadlineDe || '',
        bannerHeadlineEn: sunset.bannerHeadlineEn || '',
        bannerDetailsDe: sunset.bannerDetailsDe || '',
        bannerDetailsEn: sunset.bannerDetailsEn || '',
        messageDe: sunset.messageDe || '',
        messageEn: sunset.messageEn || '',
        contactName: sunset.contactName || '',
        contactEmail: sunset.contactEmail || '',
        contactPhone: sunset.contactPhone || '',
      }
    },
    async handleLoadSunset() {
      const orgId = this.sunsetOrgId.trim().toLowerCase()
      if (!orgId) return
      this.isLoadingSunset = true
      try {
        const sunset = await this.$store.dispatch('loadOrganizationSunset', orgId)
        this.applySunsetToDraft(sunset)
        this.sunsetOrgLoaded = true
      } catch (error: any) {
        alert(`${this.$t('sunset.loadError')}\n\n${error?.code || ''}: ${error?.message || error}`)
      }
      this.isLoadingSunset = false
    },
    async handleSunsetSubmit() {
      if (!this.sunsetDraft.effectiveAtLocal) {
        return alert(this.$t('sunset.errorEffectiveAt'))
      }
      const orgId = this.sunsetOrgId.trim().toLowerCase()
      const payload: OrganizationSunsetInterface = {
        effectiveAt: new Date(this.sunsetDraft.effectiveAtLocal),
        titleDe: this.sunsetDraft.titleDe,
        titleEn: this.sunsetDraft.titleEn,
        bannerHeadlineDe: this.sunsetDraft.bannerHeadlineDe,
        bannerHeadlineEn: this.sunsetDraft.bannerHeadlineEn,
        bannerDetailsDe: this.sunsetDraft.bannerDetailsDe,
        bannerDetailsEn: this.sunsetDraft.bannerDetailsEn,
        messageDe: this.sunsetDraft.messageDe,
        messageEn: this.sunsetDraft.messageEn,
        contactName: this.sunsetDraft.contactName,
        contactEmail: this.sunsetDraft.contactEmail,
        contactPhone: this.sunsetDraft.contactPhone,
      }
      this.isSavingSunset = true
      try {
        await this.$store.dispatch('updateOrganizationSunset', {
          organizationId: orgId,
          sunset: payload,
        })
        const sunset = await this.$store.dispatch('loadOrganizationSunset', orgId)
        this.applySunsetToDraft(sunset)
        alert(this.$t('sunset.saveSuccess'))
      } catch (error: any) {
        console.error('updateOrganizationSunset failed', error)
        const code = error?.code || ''
        if (code === 'permission-denied') {
          alert(this.$t('sunset.submitErrorPermission'))
        } else {
          alert(`${this.$t('sunset.submitError')}\n\n${code}: ${error?.message || error}`)
        }
      }
      this.isSavingSunset = false
    },
    async handleCreateOrganization(e: Event) {
      e.preventDefault()
      if (!confirm('Create organization with ID ' + this.newOrganizationId + '?')) {
        this.newOrganizationId = ''
        return
      }
      this.isCreatingOrganization = true
      try {
        await functions.creatOrganizationAsSuperAdmin(this.newOrganizationId)
        this.createdOrganizationId = this.newOrganizationId
        this.newOrganizationId = ''
        this.hasCreatedOrganization = true
      } catch (error: any) {
        alert('Could not create organization: ' + error.message)
        console.error('ERROR Creating an organization', error)
      }
      this.isCreatingOrganization = false
    },
  },
})
